import { Flex, Box } from '@cad-arc';
import React from 'react';
import loadingBackground from '../../assets/images/loading-background.jpg';

export const WindowLoadingBackground: React.FC = ({ children }) => {
    return (
        <Box background={`url(${loadingBackground})`} backgroundSize="cover" h="100vh" w="100vw">
            <Flex justifyContent="center" alignItems="center" h="100%" w="100%">
                {children}
            </Flex>
        </Box>
    );
};
